import {Pipe, PipeTransform} from '@angular/core';
@Pipe ({
   name : 'Role'
})
export class Role implements PipeTransform {
   transform(val: string): string {

    switch (val) {
        case 'ADMINISTRATOR': return 'ADMINISTRATOR';
        case 'PURCHASINGREP': return 'PURCHASING REP';
        case 'VENDOR': return 'VENDOR';
        case 'customer': return 'CUSTOMER';
        case 'SALESREP': return 'SALES REP';
        case 'CLERICALREP': return 'CLERICAL REP';
    }

    return val;
   }
}